const DEFAULT_MAX_DIMENSION = 1200;
const DEFAULT_MAX_BYTES = 500 * 1024;
const DEFAULT_QUALITY = 0.82;

function resizeAndCompress(file, maxDimension, quality) {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxDimension / Math.max(img.width, img.height));
      const targetWidth = Math.round(img.width * scale);
      const targetHeight = Math.round(img.height * scale);

      const canvas = document.createElement("canvas");
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      canvas.getContext("2d").drawImage(img, 0, 0, targetWidth, targetHeight);

      canvas.toBlob((blob) => {
        URL.revokeObjectURL(objectUrl);
        if (!blob) {
          reject(new Error("Canvas toBlob returned null"));
          return;
        }
        const jpegName = file.name.replace(/\.[^.]+$/, "") + ".jpg";
        resolve(new File([blob], jpegName, { type: "image/jpeg" }));
      }, "image/jpeg", quality);
    };
    img.onerror = (err) => {
      URL.revokeObjectURL(objectUrl);
      reject(err);
    };
    img.src = objectUrl;
  });
}

// Link-preview crawlers (WhatsApp, etc.) silently drop og:image when the file is too
// large - raw camera stills picked straight from a file input can be several MB. Cap
// dimensions and re-encode as JPEG before the file reaches a signed-url upload.
// Leaves already-small files untouched.
export async function compressImage(file, {
  maxDimension = DEFAULT_MAX_DIMENSION,
  maxBytes = DEFAULT_MAX_BYTES,
  quality = DEFAULT_QUALITY,
} = {}) {
  if (!file || file.size <= maxBytes) return file;

  try {
    return await resizeAndCompress(file, maxDimension, quality);
  } catch (err) {
    console.error("Failed to compress image, using original file", err);
    return file;
  }
}
